/* tslint:disable:no-string-literal */

import * as Preact from 'preact'
import { Link, Match } from 'preact-router/match'
import { NrkSportLogo } from '../Logos/NrkSportLogo'
import styles from './index.css'

const { h } = Preact

interface ILink {
  key?: any
  text: string
  href: string
  isExternal?: boolean
}

interface IProps {
  BASE_URL: string
  links: ILink[]
}

const HeaderLink = (props: ILink) => {
  if (props.isExternal) {
    return <a href={props.href}>{props.text}</a>
  }

  return (
    <Link
      key={props.href}
      href={props.href}
      activeClassName={styles['header__active-link']}
    >
      {props.text}
    </Link>
  )
}

const Header = ({ BASE_URL, links }: IProps) => {
  return (
    <div class={styles.header}>
      <div class={styles['header__content']}>
        <div class={styles['header__home-link']}>
          <a href="https://www.nrk.no/">Til NRK.no</a>
        </div>

        <div class={styles['header__branding']}>
          <Link href={`${BASE_URL}/`} activeClassName="">
            <NrkSportLogo class={styles['header__logo']} rounded={true} />
            <span class={styles.header__title}>FIFA Fotball-VM 2018</span>
          </Link>
        </div>

        <div class={styles['header-nav']}>
          <ul class={styles['header-nav__link-wrapper']}>
            {links.map(link => (
              <li class={styles['header-nav__link']}>
                <HeaderLink key={link.href} {...link} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export { Header }
